export const iconFontAwesomeScienceVials = (
	<i className="fa-solid fa-vials"></i>
);
